export default __webpack_public_path__ + "static/media/infinite.e0946c70.svg";